"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuItem as ChakraMenuItem, Text, Box, Flex } from "@chakra-ui/react";
import { useNavigationContext } from "./NavigationContext";
import { SvgSpriteConsumer } from "../../atoms";
import { getNavigationFocusStyle } from "./Navigation.helpers";
const NavigationItem = (_a) => {
    var { icon, rightIcon, title, description, onClick, isBackItem, withDivider, isSelected } = _a, rest = __rest(_a, ["icon", "rightIcon", "title", "description", "onClick", "isBackItem", "withDivider", "isSelected"]);
    const { closeMenu } = useNavigationContext();
    return (_jsx(ChakraMenuItem, Object.assign({ sx: getNavigationFocusStyle(), onClick: (e) => {
            if (!isBackItem) {
                closeMenu();
            }
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        } }, rest, (withDivider
        ? {
            borderBottom: "1px",
            borderBottomColor: "semantic.border.secondary",
        }
        : {}), { children: _jsxs(Flex, Object.assign({ justifyContent: "space-between", width: "inherit" }, { children: [_jsxs(Flex, Object.assign({ justifyContent: "flex-start", alignItems: "center" }, { children: [icon ? (_jsx(Box, Object.assign({ height: "6", mr: "2", color: isSelected
                                ? "semantic.interactive.primary"
                                : "semantic.text.primary" }, { children: icon }))) : null, _jsxs(Flex, Object.assign({ flexDirection: "column", justifyContent: "center", alignItems: "flex-start", paddingTop: "2%" }, { children: [_jsx(Text, Object.assign({ variant: "body.largeDemibold", color: isSelected
                                        ? "semantic.interactive.primary"
                                        : "semantic.text.primary", noOfLines: description ? 1 : 2 }, { children: title })), description ? (_jsx(Text, Object.assign({ variant: "body.mediumDemibold", noOfLines: description ? 1 : 2, color: isSelected
                                        ? "semantic.interactive.primary"
                                        : "semantic.text.secondary" }, { children: description }))) : null] }))] })), isSelected ? (_jsx(Flex, Object.assign({ color: "semantic.interactive.primary" }, { children: _jsx(SvgSpriteConsumer, { svgId: "check24", size: 24 }) }))) : null, rightIcon || null] })) })));
};
NavigationItem.displayName = "NavigationItem";
export default NavigationItem;
//# sourceMappingURL=NavigationItem.js.map